var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIndication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45447 9.70312L8.2776 6.42703C8.33919 6.37422 8.38863 6.30872 8.42252 6.23501C8.45642 6.1613 8.47397 6.08113 8.47397 6C8.47397 5.91887 8.45642 5.8387 8.42252 5.76499C8.38863 5.69128 8.33919 5.62577 8.2776 5.57297L4.45447 2.29687C4.08955 1.98422 3.52588 2.24344 3.52588 2.72391L3.52588 9.27703C3.52588 9.7575 4.08955 10.0167 4.45447 9.70312Z",
    fill: "#0E0F0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIndication);
export default __webpack_public_path__ + "static/media/rightIndication.5695d26f95ef381bf02a7a71cc8f1152.svg";
export { ForwardRef as ReactComponent };